import { createContext, Dispatch, SetStateAction, useContext } from 'react';
import { Hospital } from 'types/hospital';
import { ProcedureDoctor, ProcedurePackage } from 'types/procedure';
import { SurgerieFormData } from 'types/surgerie';

export type NewSurgerieContextData = {
  validation: string;
  surgerie: SurgerieFormData;
  loadingHospitals: boolean;
  doctors: ProcedureDoctor[];
  hospitals: Hospital[];
  handleChangePackages(packages: ProcedurePackage[]): void;
  handleChange<K extends keyof SurgerieFormData>(key: K, value: SurgerieFormData[K]): void;
};

const NewSurgerieContext = createContext<NewSurgerieContextData>({} as NewSurgerieContextData);
export const NewSurgerieProvider = NewSurgerieContext.Provider;
export const NewSurgerieConsumer = NewSurgerieContext.Consumer;

export function useNewSurgerie(): NewSurgerieContextData {
  const context = useContext(NewSurgerieContext);
  return context;
}
